module.exports = __webpack_public_path__ + "i18n/tr.b08ce91e070c87c5bc3c2967fc17273c.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=i18n/[name].[hash].[ext]!./i18n/tr.json
// module id = 1009
// module chunks = 60